import { i18n } from "services/i18nService";
import { formatDate } from "services/utility/dates";
import { formatDecimal, extractName } from "services/utility/formatting";

export const onSr = {
  relatedObjectType: "salesreceipt",
  headerText: i18n("modalHeader.onSr"),
  note: i18n("notes.onSoSr"),
  columns: [
    {
      jsonName: "refNumber",
      label: i18n("columns.ReferenceNumber"),
      linkColumn: true,
      sortable: true,
    },
    {
      jsonName: "txnDate",
      label: i18n("columns.TxnDate"),
      formatFunc: formatDate,
      sortable: true,
    },
    {
      jsonName: "location",
      label: i18n("columns.Location"),
      formatFunc: extractName,
      sortable: true,
    },
    {
      jsonName: "item",
      label: i18n("columns.Item"),
      formatFunc: extractName,
      sortable: true,
    },
    {
      jsonName: "quantity",
      label: i18n("columns.Quantity"),
      formatFunc: formatDecimal,
      number: true,
    },
    {
      jsonName: "shipped",
      label: i18n("columns.Shipped"),
      formatFunc: formatDecimal,
      number: true,
    },
    {
      jsonName: "customer",
      label: i18n("columns.Customer"),
      formatFunc: extractName,
      sortable: true,
    },
    { jsonName: "memo", label: i18n("columns.Memo") },
    {
      jsonName: "dueDate",
      label: i18n("columns.DueDate"),
      formatFunc: formatDate,
      sortable: true,
    },
  ],
  FIELDS_TO_TRANSFORM: {
    DECIMAL_FIELDS: ["quantity", "shipped"],
    MONEY_FIELDS: [],
    DATE_FIELDS: ["txnDate", "dueDate"],
    DATETIME_FIELDS: [],
    NON_UTC_DATETIME_FIELDS: [],
  },
};
